import { AreaLocation } from './../../+grid-application-shared/entities/personal-data/areaLocation';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { forkJoin, Observable, of } from 'rxjs';

import { InstallationFlowType } from '../../constants/app.constants';
import { CompanyData, FormTypesData, KeyValueData, TechnicianData } from '../../domains/common.domain';
import { CommonService } from '../../services/common.service';
import { ErrorService } from '../../services/error/error.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { NavigationStateShareService } from '../../services/navigation-state-share.service';
import { AllDropdownKeys, ComponentRoutes, UrlSegments } from '../jurisdiction.constants';
import { PersonalDataService } from './personal-data.service';
import {
  BusinessPartnerResponse,
  ConnectionObjectResponse,
  CreateFeedInConstructorResponse,
  InvoiceAddressFormData,
  InvoiceAddressResponse,
  UpdateApplicationStatusRequest,
  UpdateBusinessPartnerResponse,
  UpdateConnectionObjectResponse,
  UpdateInstallerData,
  UpdateInvoiceAddressResponse,
  Document,
} from '../jurisdiction.domain';
import { GetInstallationApplicationObject, InstallationApplicationData } from '../facilities-form/facilities-form.domain';
import {
  GetGridConnectionObject,
  GridConnectionData,
  UpdateGasGridConnection,
  UpdateHeatingGridConnection,
  UpdatePowerGridConnection,
  UpdateWaterGridConnection,
} from '../technician-data/technician-data.domain';
import { CommunicationService } from '../../services/communication.service';
import { JurisdictionService } from '../jurisdiction.service';
import { EnvironmentService } from '../../services/environment.service';
import { catchError } from 'rxjs/operators';
import { TechnicianResponseData } from '../../employee-overview/employee-overview.domain';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { CustomFieldsService } from 'src/app/+shared/custom-fields/custom-fields.service';
import { CustomField } from 'src/app/+shared/custom-fields/models';
import { ComponentCanDeactivate } from 'src/app/+shared/guards/pending-changes-guard.servie';
import { SectionIdentifier } from 'src/app/+shared/components/review-section/review-section.domain';
import { hideButtonsForChimneySweeper } from '../../../app/+shared/components/review-section/review-section.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  providers: [PersonalDataService],
  selector: 'app-personal-data',
  styleUrls: ['./personal-data.component.scss'],
  templateUrl: './personal-data.component.html',
})
export class PersonalDataComponent extends DestroyableComponent implements OnInit, ComponentCanDeactivate {
  @Input() isReadOnly: boolean = false;

  buildingTypeKey: string;
  businessPartnerId: string = '';
  changeConnectionType: string;
  changeSubtypeKey: string;
  connectionData: any;
  connectionObjectId: string = '';
  currentFormType: FormTypesData;
  currentInstallationFlow: string;
  disableFormButtons: boolean;
  externalApplicationId: string;
  feedInTypeKey: string;
  feedInInstallationType: string;
  installationFlowType: KeyValueData;
  installerCompanyData: any;
  installerData: any;
  invoiceAddress: any;
  isLoading: boolean = false;
  isFormSavedSuccessfully: boolean = true;
  constructorId: string;
  installerId: string;
  apartmentHouseType: string;
  personalDataFormValues: {
    connectionAddressData: FormGroup;
    installerData: FormGroup;
    subscriberData: FormGroup;
    installerSystemData: FormGroup;
    invoiceAddress: FormGroup;
    installerCompanyData: FormGroup;
  };
  selectedFacilityTypes: FormTypesData[];
  showInstallerComponent: boolean;
  showInstallerCompanyComponent: boolean;
  showTechnicianDataTitle: boolean;
  subscriberData: any;
  technicianData: TechnicianData = null;
  responsibleInstallerData: CompanyData = null;
  technicianFormTypes: FormTypesData[];
  technicianId: string;
  isDetailsView: boolean;
  preventCanDeactivateCheck: boolean = false;

  customFields$: Observable<CustomField[]>;
  documents: Document[];
  areaLocations: AreaLocation[] = [];
  applicationId: number;

  ConnectionAddressSectionIdentifier = SectionIdentifier.PersonalData_ConnectionAddress;
  ConnectionAddressSectionSubscriber = SectionIdentifier.PersonalData_Subscriber;
  hideButtonsForChimneySweeper = hideButtonsForChimneySweeper;

  get showInvoiceAddress() {
    return (
      this.environmentService.showInvoiceAddressPerApplication(this.currentInstallationFlow) &&
      this.personalDataFormValues.subscriberData.value?.invoiceRecipient === false
    );
  }

  constructor(
    private commonService: CommonService,
    private errorService: ErrorService,
    private jurisdictionService: JurisdictionService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private stateShare: NavigationStateShareService,
    private personalDataService: PersonalDataService,
    private communicationService: CommunicationService,
    private cdr: ChangeDetectorRef,
    private environmentService: EnvironmentService,
    private route: ActivatedRoute,
    private customFieldsService: CustomFieldsService
  ) {
    super();
    this.installationFlowType = InstallationFlowType;
    this.disableFormButtons = true;
  }

  canDeactivate(): boolean {
    if (this.preventCanDeactivateCheck) {
      return true;
    }

    return (
      !this.personalDataFormValues.connectionAddressData?.dirty &&
      !this.personalDataFormValues.installerCompanyData?.dirty &&
      !this.personalDataFormValues.installerData?.dirty &&
      !this.personalDataFormValues.installerSystemData?.dirty &&
      !this.personalDataFormValues.invoiceAddress?.dirty &&
      !this.personalDataFormValues.subscriberData?.dirty
    );
  }

  ngOnInit(): void {
    this.applicationId = parseInt(this.localStorageService.getItem('application_id'));
    this.preventLeak(this.route.url).subscribe(urlSegments => {
      this.isDetailsView = urlSegments[0].path === ComponentRoutes.ProcessDetails;
    });

    this.technicianId = '';
    this.buildingTypeKey = AllDropdownKeys.BuildingType;
    this.changeSubtypeKey = AllDropdownKeys.ChangeSubtype;
    this.currentInstallationFlow = this.localStorageService.getItem('installation_flow') || '';
    this.selectedFacilityTypes = this.localStorageService.getItem('selected_facilities') || '';
    this.changeConnectionType = this.localStorageService.getItem('selected_change_type') || '';
    this.showInstallerComponent = false;
    this.showInstallerCompanyComponent = false;
    this.constructorId = this.localStorageService.getItem('constructor_id');
    this.installerId = this.localStorageService.getItem('installer_id');
    this.feedInTypeKey = AllDropdownKeys.FeedInType;
    this.feedInInstallationType = this.localStorageService.getItem('feedin_inst_type') || '';

    this.customFieldsService.loadCustomFieldConfigForApplication(this.currentInstallationFlow);
    this.evaluateForTechnicianDataFlow();

    this.technicianFormTypes =
      this.currentInstallationFlow === InstallationFlowType.MainsConnection
        ? this.localStorageService.getItem('selected_building_type')
        : this.commonService.getTechnicianFlow(this.currentInstallationFlow, this.changeConnectionType);

    if (this.technicianFormTypes.length) {
      this.setCurrentFormType();
    }

    this.personalDataFormValues = this.localStorageService.getItem('personal_data') || {
      connectionAddressData: {},
      installerData: {},
      subscriberData: {},
      installerCompanyData: {},
      installerSystemData: {},
    };
    this.getData();
    this.personalDataService.registerForConnectionAddressUpdate.subscribe(data => {
      this.personalDataFormValues.connectionAddressData = data;
      this.evaluateFormValidity();
    });
    this.personalDataService.registerForInstallerUpdate.subscribe(data => {
      this.personalDataFormValues.installerData = data;
      this.evaluateFormValidity();
    });
    this.personalDataService.registerForSubscriberUpdate.subscribe(data => {
      this.personalDataFormValues.subscriberData = data;
      this.evaluateFormValidity();
    });
    this.personalDataService.registerForInstallerCompanyUpdate.subscribe(data => {
      this.personalDataFormValues.installerCompanyData = data;
      this.evaluateFormValidity();
    });
    this.personalDataService.registerForInstallerSystemUpdate.subscribe(data => {
      this.personalDataFormValues.installerSystemData = data;
      this.evaluateFormValidity();
    });
    this.personalDataService.registerForInvoiceAddressUpdate.subscribe(data => {
      this.personalDataFormValues.invoiceAddress = data;
      this.evaluateFormValidity();
    });
  }

  setCurrentFormType(): void {
    this.currentFormType = this.jurisdictionService.setCurrentFormType(this.currentFormType, this.technicianFormTypes);
  }

  evaluateFormValidity(): void {
    this.disableFormButtons =
      !!this.personalDataFormValues.connectionAddressData.invalid || !!this.personalDataFormValues.subscriberData.invalid;

    if (this.personalDataFormValues.installerData) {
      this.disableFormButtons = this.disableFormButtons || !!this.personalDataFormValues.installerData.invalid;
    }

    if (this.personalDataFormValues.installerCompanyData) {
      this.disableFormButtons = this.disableFormButtons || !!this.personalDataFormValues.installerCompanyData.invalid;
    }
    if (this.personalDataFormValues.installerSystemData) {
      this.disableFormButtons = this.disableFormButtons || !!this.personalDataFormValues.installerSystemData.invalid;
    }
    if (this.personalDataFormValues.invoiceAddress && this.showInvoiceAddress) {
      this.disableFormButtons = this.disableFormButtons || !!this.personalDataFormValues.invoiceAddress.invalid;
    }
  }

  evaluateComponentVisibility(): void {
    const role = this.isReadOnly ? this.technicianData?.role : this.localStorageService.getItem('role');
    this.showInstallerComponent = this.environmentService.responsibleInstaller && role === 'customer';
    switch (this.currentInstallationFlow) {
      case this.installationFlowType.FeedInSystem:
        this.showInstallerCompanyComponent = true;
        break;
    }
    this.cdr.detectChanges();
  }

  saveFormData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      const allSubscriptions = [];
      this.isFormSavedSuccessfully = true;
      const subscriptionObject = {
        businessPartner: -1,
        connectionObject: -1,
        applicationsData: -1,
        constructionData: -1,
        invoiceAddress: -1,
        technicianData: -1,
      };

      allSubscriptions.push(this.saveConnectionObjectData());
      subscriptionObject.connectionObject = allSubscriptions.length - 1;

      allSubscriptions.push(this.saveBusinessPartnerData());
      subscriptionObject.businessPartner = allSubscriptions.length - 1;

      allSubscriptions.push(this.saveApplicationData());
      subscriptionObject.applicationsData = allSubscriptions.length - 1;

      if (this.showInvoiceAddress && this.personalDataFormValues.invoiceAddress?.valid) {
        allSubscriptions.push(this.saveInvoiceAddress());
        subscriptionObject.invoiceAddress = allSubscriptions.length - 1;
      }

      if (this.currentInstallationFlow === InstallationFlowType.FeedInSystem) {
        allSubscriptions.push(this.saveConstructorData());
        subscriptionObject.constructionData = allSubscriptions.length - 1;
      }

      if (
        this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
        this.currentInstallationFlow === this.installationFlowType.TemporaryConnection
      ) {
        allSubscriptions.push(...this.saveTechnicianData());
        subscriptionObject.technicianData = allSubscriptions.length - 1;
      }

      forkJoin(allSubscriptions).subscribe(
        response => {
          const error = response.find(r => r instanceof HttpErrorResponse);
          if (error) {
            this.isLoading = false;
            reject(error);
            this.errorService.throwErrorIfFailure(response, true);
            return;
          }

          resolve();

          if (subscriptionObject.connectionObject > -1) {
            this.postSaveConnectionObjectData(response[subscriptionObject.connectionObject]);
          }
          if (subscriptionObject.businessPartner > -1) {
            this.postSaveBusinessPartnerData(response[subscriptionObject.businessPartner]);
          }
          if (subscriptionObject.constructionData > -1) {
            this.postSaveConstructorData(response[subscriptionObject.constructionData]);
          }
          if (subscriptionObject.applicationsData > -1) {
            this.postSaveApplicationData(response[subscriptionObject.applicationsData]);
          }
          if (subscriptionObject.invoiceAddress > -1) {
            this.postSaveInvoiceAddress(response[subscriptionObject.invoiceAddress]);
          }
          if (subscriptionObject.technicianData > -1) {
            this.postSaveTechnicianData(response[subscriptionObject.technicianData]);
          }
          if (this.isFormSavedSuccessfully) {
            this.isLoading = false;
            this.postSuccessfulSave();
          }
        },
        error => {
          reject();
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    });
  }

  getFlowTitle(): string {
    return this.commonService.parseTextFromCamelCase(this.currentInstallationFlow);
  }

  errorHandler = (): void => {
    this.isLoading = false;
    this.isFormSavedSuccessfully = false;
  };

  public loadResponsibleInstallerData(tempConnectionConfirmed: boolean): void {
    if (!this.personalDataFormValues.installerData?.value) return;

    if (tempConnectionConfirmed && this.responsibleInstallerData) {
      this.personalDataFormValues.installerData.patchValue({
        power: {
          taxId: this.responsibleInstallerData.tax_id,
          companyName: this.responsibleInstallerData.company_name,
          telephoneNumber: this.responsibleInstallerData.telephone,
        },
      });
    } else {
      this.personalDataFormValues.installerData.patchValue({
        power: { taxId: null, companyName: null, telephoneNumber: null },
      });
    }
  }

  public removeAreaLocation(location: AreaLocation): void {
    this.areaLocations = this.areaLocations.filter(x => x !== location);
  }

  private getData(): void {
    if (
      this.currentInstallationFlow === InstallationFlowType.NewInstallation ||
      this.currentInstallationFlow === InstallationFlowType.UpdateInstallation ||
      this.currentInstallationFlow === InstallationFlowType.FeedInSystem ||
      this.currentInstallationFlow === InstallationFlowType.SiteElectricityMeterdata
    ) {
      this.getInstallationApplicationData();
    } else if (
      this.currentInstallationFlow === InstallationFlowType.MainsConnection ||
      this.currentInstallationFlow === InstallationFlowType.TemporaryConnection ||
      this.currentInstallationFlow === InstallationFlowType.ChangeHouseConnection ||
      this.currentInstallationFlow === InstallationFlowType.ConversionToGas
    ) {
      this.getGridConnectionData();
    } else {
      this.prepareForms(null);
    }
  }

  public areLocationFieldsHidden() {
    return !(this.areaLocations && this.areaLocations[0]?.area);
  }

  private getInstallationApplicationData(): void {
    const applicationId = this.localStorageService.getItem('application_id');

    if (applicationId && !this.isReadOnly) {
      this.isLoading = true;
      this.commonService.getInstallationApplication(applicationId).subscribe(
        (response: GetInstallationApplicationObject) => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(response, true);
          this.commonService.installationApplicationData = response.installationapplication[0];
          const locationObject = response.installationapplication[0]?.location?.location_object;
          if (locationObject) {
            this.commonService.locationData = JSON.parse(locationObject);
            this.initAreaLocations([
              {
                area: this.commonService.locationData.area,
                field: this.commonService.locationData.field,
                field_sector: this.commonService.locationData.field_sector,
              },
            ]);
          }
          this.parseInstallationData();
        },
        error => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    } else {
      this.parseInstallationData();
      this.initAreaLocations(this.commonService.installationApplicationData.connectionobject?.area_locations);
    }
  }

  private parseInstallationData() {
    const installationData: InstallationApplicationData = { ...this.commonService.installationApplicationData };

    if (installationData.feedininstallation.constructor) {
      this.constructorId = installationData.feedininstallation.constructor.constructor_id;
    }

    this.externalApplicationId = this.commonService.installationApplicationId;
    if (this.currentInstallationFlow === InstallationFlowType.FeedInSystem) {
      this.feedInInstallationType = this.feedInInstallationType || installationData.feedininstallation?.sk_feedin_inst_type || '';
    }

    this.technicianId = installationData.technician_id || '';
    this.prepareForms(installationData);
  }

  private getGridConnectionData(): void {
    const data = this.commonService.gridConnectionApplicationData || null;

    const applicationId = this.localStorageService.getItem('application_id');
    if (applicationId && !this.isReadOnly) {
      this.isLoading = true;
      this.commonService.getGridConnectionApplication(applicationId).subscribe(
        (response: GetGridConnectionObject) => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(response, true);

          this.commonService.gridConnectionApplicationData = response.gridconapplication[0];

          this.technicianId = response.gridconapplication[0].user_id || '';
          this.externalApplicationId = this.commonService.griConnectionApplicationId;
          this.prepareForms(response.gridconapplication[0]);
          this.initAreaLocations(response.gridconapplication[0]?.connectionobject?.area_locations);
        },
        error => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    } else {
      this.technicianId = data.user_id || '';
      this.externalApplicationId = this.commonService.griConnectionApplicationId;
      this.prepareForms(data);
      this.initAreaLocations(this.commonService.gridConnectionApplicationData.connectionobject?.area_locations);
    }
  }

  private prepareForms(data: InstallationApplicationData | GridConnectionData): void {
    if (this.commonService.takeFromRequestOne) {
      this.subscriberData = this.personalDataFormValues.subscriberData || {};
      this.connectionData = this.personalDataFormValues.connectionAddressData || {};
      this.installerData = this.personalDataFormValues.installerData || {};
      this.installerCompanyData = this.personalDataFormValues.installerCompanyData || {};
      this.invoiceAddress = this.personalDataFormValues.invoiceAddress || {};
    } else {
      this.subscriberData =
        (data && this.personalDataService.parseBusinessPartnerData(data.businesspartner)) ||
        this.personalDataFormValues.subscriberData ||
        {};
      this.connectionData =
        (data && this.personalDataService.parseConnectionObjectData(data.connectionobject)) ||
        this.personalDataFormValues.connectionAddressData ||
        {};
      if (
        this.currentInstallationFlow === this.installationFlowType.MainsConnection ||
        this.currentInstallationFlow === this.installationFlowType.TemporaryConnection
      ) {
        this.installerData = this.personalDataService.parseInstallerData() || {};
        this.invoiceAddress = this.personalDataService.parseInvoiceAddressData(data.invoicerecipient);
      } else {
        this.installerData = this.personalDataFormValues.installerData || {};
        this.invoiceAddress = this.personalDataService.parseInvoiceAddressData(data.invoicerecipient);
      }
      if (this.currentInstallationFlow === this.installationFlowType.FeedInSystem) {
        this.installerCompanyData =
          (data &&
            this.personalDataService.parseInstallerCompanyData(
              (data as InstallationApplicationData).feedininstallation.constructor,
              (data as InstallationApplicationData).feedininstallation.installer
            )) ||
          this.personalDataFormValues.installerCompanyData;
        this.invoiceAddress = this.personalDataService.parseInvoiceAddressData(data.invoicerecipient);
      }
      this.documents = data.document;
    }
    this.subscriberData.landowner = data.applicant_is_landowner === '1';
    this.subscriberData.invoiceRecipient = data.applicant_is_invoicerecipient === '1';

    if (this.isReadOnly || this.isDetailsView) {
      this.getTechnicianData();
    } else {
      this.evaluateComponentVisibility();
    }
  }

  private getTechnicianData(): void {
    this.isLoading = true;
    this.communicationService.getData(`technician?technician_id=${this.technicianId}`).subscribe(
      (response: TechnicianResponseData) => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(response, true);
        this.technicianData = (response.technician && response.technician[0]) || null;
        this.evaluateComponentVisibility();
        this.getResponsibleInstallerData();
      },
      error => {
        this.isLoading = false;
        this.errorService.throwErrorIfFailure(error, true);
      }
    );
  }

  private getResponsibleInstallerData(): void {
    const loggedInTechnicianId = this.localStorageService.getItem('technician_id');
    if (this.showInstallerComponent && loggedInTechnicianId) {
      this.isLoading = true;
      this.communicationService.getData(`technician?technician_id=${loggedInTechnicianId}`).subscribe(
        (response: TechnicianResponseData) => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(response, true);
          this.responsibleInstallerData =
            (response.technician && response.technician[0] && response.technician[0].company && response.technician[0].company[0]) || null;
        },
        error => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    }
  }

  private saveConnectionObjectData(): Observable<ConnectionObjectResponse | UpdateConnectionObjectResponse> {
    this.connectionObjectId =
      this.currentInstallationFlow === this.installationFlowType.NewInstallation ||
      this.currentInstallationFlow === this.installationFlowType.UpdateInstallation ||
      this.currentInstallationFlow === this.installationFlowType.FeedInSystem ||
      this.currentInstallationFlow === this.installationFlowType.SiteElectricityMeterdata
        ? this.localStorageService.getItem('connection_object_id')
        : this.commonService.allGridConnectionIds.connectionObjectId || this.localStorageService.getItem('connection_object_id') || '';

    const requestUrlSegment = this.connectionObjectId
      ? `${UrlSegments.UpdateConnectionObject}=${this.connectionObjectId}`
      : UrlSegments.SaveConnectionObject;

    const connectionAddressData =
      this.personalDataFormValues.connectionAddressData &&
      this.personalDataService.getFormValues(this.personalDataFormValues.connectionAddressData);
    const connectionRequestData = this.personalDataService.prepareConnectionRequestData(
      connectionAddressData,
      this.connectionObjectId,
      this.areaLocations
    );

    return this.connectionObjectId
      ? this.personalDataService.updateConnectionObjectData(requestUrlSegment, connectionRequestData).pipe(catchError(error => of(error)))
      : this.personalDataService.saveConnectionObjectData(requestUrlSegment, connectionRequestData).pipe(catchError(error => of(error)));
  }

  private postSaveConnectionObjectData(connectionObjectResponse: ConnectionObjectResponse | UpdateConnectionObjectResponse | unknown) {
    this.errorService.throwErrorIfFailure(connectionObjectResponse, true, this.errorHandler);
    if (!this.connectionObjectId && (connectionObjectResponse as ConnectionObjectResponse).connectionobject) {
      this.connectionObjectId = (connectionObjectResponse as ConnectionObjectResponse).connectionobject[0].connectionobject_id;
      this.localStorageService.setItem('connection_object_id', this.connectionObjectId);
    }
  }

  private saveBusinessPartnerData(): Observable<BusinessPartnerResponse | UpdateBusinessPartnerResponse> {
    this.businessPartnerId =
      this.currentInstallationFlow === this.installationFlowType.NewInstallation ||
      this.currentInstallationFlow === this.installationFlowType.UpdateInstallation ||
      this.currentInstallationFlow === this.installationFlowType.FeedInSystem ||
      this.currentInstallationFlow === this.installationFlowType.SiteElectricityMeterdata
        ? this.localStorageService.getItem('business_partner_id')
        : this.commonService.allGridConnectionIds.businessPartnerId || this.localStorageService.getItem('business_partner_id') || '';

    const requestUrlSegment = this.businessPartnerId
      ? `${UrlSegments.UpdateBusinessPartner}=${this.businessPartnerId}`
      : UrlSegments.SaveBusinessPartner;

    const subscriberData =
      this.personalDataFormValues.subscriberData && this.personalDataService.getFormValues(this.personalDataFormValues.subscriberData);
    const businessRequestData = this.personalDataService.prepareBusinessRequestData(subscriberData, this.businessPartnerId);
    return this.businessPartnerId
      ? this.personalDataService.updateBusinessPartnerData(requestUrlSegment, businessRequestData).pipe(catchError(error => of(error)))
      : this.personalDataService.saveBusinessPartnerData(requestUrlSegment, businessRequestData).pipe(catchError(error => of(error)));
  }

  private postSaveBusinessPartnerData(businessPartnerResponse: BusinessPartnerResponse | UpdateBusinessPartnerResponse | unknown) {
    this.errorService.throwErrorIfFailure(businessPartnerResponse, true, this.errorHandler);
    if (!this.businessPartnerId && (businessPartnerResponse as BusinessPartnerResponse).businesspartner) {
      this.businessPartnerId = (businessPartnerResponse as BusinessPartnerResponse).businesspartner[0].businesspartner_id;
      this.localStorageService.setItem('business_partner_id', this.businessPartnerId);
    }
  }

  private saveConstructorData(): Observable<unknown> {
    const installerSystemData = this.personalDataService.getFormValues(this.personalDataFormValues.installerSystemData);
    let requestUrl = UrlSegments.FeedInConstructor;
    const requestData = this.personalDataService.prepareConstructorRequestObject(installerSystemData);
    if (this.constructorId) {
      delete requestData.installation_id;
      requestUrl = UrlSegments.FeedInConstructor + '?constructor_id=' + this.constructorId;

      return this.communicationService.updateData(`${requestUrl}`, requestData).pipe(catchError(error => of(error)));
    } else {
      return this.communicationService.postData(`${requestUrl}`, requestData).pipe(catchError(error => of(error)));
    }
  }

  /*private saveInstallerCompanyFormData(): void {
   const installerData = this.personalDataService.getFormValues(this.personalDataFormValues.installerCompanyData);
   let requestUrl = UrlSegments.FeedInInstaller;
   const requestData = this.personalDataService.prepareInstallerRequestObject(installerData);
   if (this.installerId) {
   delete requestData.installation_id;
   requestUrl = UrlSegments.FeedInInstaller + '?installer_id=' + this.installerId;
   this.subscriptionCount += 1;
   this.communicationService.updateData(`${requestUrl}`, requestData).subscribe(response => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(response, true);
   this.postSuccessfulSave();
   }, (error) => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(error, true);
   });
   } else {
   this.subscriptionCount += 1;
   this.communicationService.postData(`${requestUrl}`, requestData)
   .subscribe((response: CreateFeedInInstallerResponse) => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(response, true);
   this.localStorageService.setItem('installer_id', response.feedininstaller[0].installer_id);
   this.postSuccessfulSave();
   }, (error) => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(error, true);
   });
   }
   }*/

  private postSaveConstructorData(constructorResponse: CreateFeedInConstructorResponse | unknown) {
    this.errorService.throwErrorIfFailure(constructorResponse, true, this.errorHandler);
    if (!this.constructorId && (constructorResponse as CreateFeedInConstructorResponse).feedinconstructor) {
      this.constructorId = (constructorResponse as CreateFeedInConstructorResponse).feedinconstructor[0].constructor_id;
      this.localStorageService.setItem('constructor_id', this.constructorId);
    }
  }

  private saveApplicationData(): Observable<unknown> {
    const installationFlows = [
      this.installationFlowType.FeedInSystem,
      this.installationFlowType.NewInstallation,
      this.installationFlowType.UpdateInstallation,
      this.installationFlowType.SiteElectricityMeterdata,
    ];

    const urlSegment: string = installationFlows.includes(this.currentInstallationFlow)
      ? UrlSegments.InstallationApplication
      : UrlSegments.GridConnectionApplication;
    const applicationId = this.localStorageService.getItem('application_id');

    const subscriberData =
      this.personalDataFormValues.subscriberData && this.personalDataService.getFormValues(this.personalDataFormValues.subscriberData);

    const switchDefaultValue = this.environmentService.setDefaultToggleStates ? true : false;
    const showInvoiceRecepientSwitch = this.environmentService.showInvoiceAddressPerApplication(this.currentInstallationFlow);
    const showLandownerRecipientSwitch = this.environmentService.showLandownerPerApplication(this.currentInstallationFlow);
    const submitRequestObject: UpdateApplicationStatusRequest = {
      applicant_is_invoicerecipient: subscriberData.invoiceRecipient ? '1' : switchDefaultValue && !showInvoiceRecepientSwitch ? '1' : '0',
      applicant_is_landowner: subscriberData.landowner ? '1' : switchDefaultValue && !showLandownerRecipientSwitch ? '1' : '0',
    };
    if (subscriberData.hasOwnProperty('landowner')) {
      this.jurisdictionService.isApplicantLandowner = subscriberData.landowner;
    }

    if (applicationId) {
      return this.communicationService
        .updateData(`${urlSegment}${applicationId}`, submitRequestObject)
        .pipe(catchError(error => of(error)));
    }
  }

  private postSaveApplicationData(applicationData: unknown) {
    this.errorService.throwErrorIfFailure(applicationData, true, this.errorHandler);
  }

  private saveInvoiceAddress(): Observable<InvoiceAddressResponse | UpdateInvoiceAddressResponse> {
    const invoiceAddressData: InvoiceAddressFormData = this.personalDataService.getFormValues(this.personalDataFormValues.invoiceAddress);
    const requestData = this.personalDataService.prepareInvoiceAddressData(invoiceAddressData);
    const requestUrl = invoiceAddressData.id
      ? `${UrlSegments.UpdateInvoiceAddress}${invoiceAddressData.id}`
      : UrlSegments.SaveInvoiceAddress;

    return invoiceAddressData.id
      ? this.communicationService.updateData(requestUrl, requestData).pipe(catchError(error => of(error)))
      : this.communicationService.postData(requestUrl, requestData).pipe(catchError(error => of(error)));
  }

  /*  private saveInstallerFromData(): void {
   const installerData = this.personalDataService.getFormValues(this.personalDataFormValues.installerData);
   let requestUrl = UrlSegments.FeedInInstaller;
   const requestData = this.personalDataService.prepareInstallerRequestObject(installerData);
   if (this.installerId) {
   delete requestData.installation_id;
   requestUrl = UrlSegments.FeedInInstaller + '?installer_id=' + this.installerId;
   this.subscriptionCount += 1;
   this.communicationService.updateData(`${requestUrl}`, requestData).subscribe(response => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(response, true);
   this.postSuccessfulSave();
   }, (error) => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(error, true);
   });
   } else {
   this.subscriptionCount += 1;
   this.communicationService.postData(`${requestUrl}`, requestData)
   .subscribe((response: CreateFeedInInstallerResponse) => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(response, true);
   this.localStorageService.setItem('installer_id', response.feedininstaller[0].installer_id);
   this.postSuccessfulSave();
   }, (error) => {
   this.subscriptionCount -= 1;
   this.errorService.throwErrorIfFailure(error, true);
   });
   }
   }*/

  private postSaveInvoiceAddress(invoiceAddressResponse: InvoiceAddressResponse | UpdateInvoiceAddressResponse | unknown) {
    this.errorService.throwErrorIfFailure(invoiceAddressResponse, true, this.errorHandler);
  }

  private saveTechnicianData(): Observable<
    UpdateGasGridConnection | UpdatePowerGridConnection | UpdateWaterGridConnection | UpdateHeatingGridConnection
  >[] {
    const gridConnectionIds = this.commonService.allGridConnectionIds;
    const gridConSubscriptions = [];

    const requestData: UpdateInstallerData = this.personalDataService.prepareInstallerData(
      this.personalDataFormValues.installerData?.value
    );

    if (requestData.districtheatgridcon) {
      const requestUrl = `${UrlSegments.UpdateHeatingGridConnection}${gridConnectionIds.heatingConnectionId}`;
      gridConSubscriptions.push(
        this.personalDataService.saveInstallerData(requestUrl, requestData.districtheatgridcon).pipe(catchError(error => of(error)))
      );
    }

    if (requestData.gasgridcon) {
      const requestUrl = `${UrlSegments.UpdateGasGridConnection}${gridConnectionIds.gasConnectionId}`;
      gridConSubscriptions.push(
        this.personalDataService.saveInstallerData(requestUrl, requestData.gasgridcon).pipe(catchError(error => of(error)))
      );
    }

    if (requestData.powergridcon) {
      const requestUrl = `${UrlSegments.UpdatePowerGridConnection}${gridConnectionIds.powerConnectionId}`;
      gridConSubscriptions.push(
        this.personalDataService.saveInstallerData(requestUrl, requestData.powergridcon).pipe(catchError(error => of(error)))
      );
    }

    if (requestData.watergridcon) {
      const requestUrl = `${UrlSegments.UpdateWaterGridConnection}${gridConnectionIds.waterConnectionId}`;
      gridConSubscriptions.push(
        this.personalDataService.saveInstallerData(requestUrl, requestData.watergridcon).pipe(catchError(error => of(error)))
      );
    }
    return gridConSubscriptions;
  }

  private postSaveTechnicianData(
    technicianDataResponse:
      | UpdateGasGridConnection
      | UpdatePowerGridConnection
      | UpdateWaterGridConnection
      | UpdateHeatingGridConnection
      | unknown
  ) {
    this.errorService.throwErrorIfFailure(technicianDataResponse, true, this.errorHandler);
  }

  private postSuccessfulSave(): void {
    const personalDataValue = {
      connectionAddressData:
        this.personalDataFormValues.connectionAddressData &&
        this.personalDataService.getFormValues(this.personalDataFormValues.connectionAddressData),
      installerData: this.personalDataFormValues.installerData && this.personalDataFormValues.installerData.value,
      subscriberData:
        this.personalDataFormValues.subscriberData && this.personalDataService.getFormValues(this.personalDataFormValues.subscriberData),
      installerCompanyData: this.personalDataFormValues.installerCompanyData && this.personalDataFormValues.installerCompanyData.value,
      installerSystemData: this.personalDataFormValues.installerSystemData?.value,
      invoiceAddress:
        this.personalDataFormValues.invoiceAddress?.value &&
        this.personalDataService.getFormValues(this.personalDataFormValues.invoiceAddress),
    };

    if (!this.isDetailsView) {
      if (
        this.currentInstallationFlow !== InstallationFlowType.ChangeHouseConnection &&
        this.currentInstallationFlow !== InstallationFlowType.ConversionToGas
      ) {
        this.localStorageService.setItem('personal_data', personalDataValue);
      }
      if (
        this.environmentService.showTechnicalFormFirst ||
        this.currentInstallationFlow === InstallationFlowType.MainsConnection ||
        this.currentInstallationFlow === InstallationFlowType.FeedInSystem ||
        this.currentInstallationFlow === InstallationFlowType.TemporaryConnection ||
        this.currentInstallationFlow === InstallationFlowType.ChangeHouseConnection ||
        this.currentInstallationFlow === InstallationFlowType.ConversionToGas
      ) {
        this.preventCanDeactivateCheck = true;
        this.router.navigate(['/documents-submission']);
        this.stateShare.setFormState(4);
      } else {
        this.preventCanDeactivateCheck = true;
        this.router.navigate(['/facilities-data']);
        this.stateShare.setFormState(3);
      }
    }
  }

  private evaluateForTechnicianDataFlow(): void {
    this.showTechnicianDataTitle =
      this.currentInstallationFlow !== this.installationFlowType.NewInstallation &&
      this.currentInstallationFlow !== this.installationFlowType.UpdateInstallation;
  }

  initAreaLocations(areaLocations: AreaLocation[]) {
    areaLocations = areaLocations || this.localStorageService.getItem('area_locations') || [];
    for (let al of areaLocations) {
      al.areaOption = { area: al.area, zip: al.postcode };
    }

    this.areaLocations = areaLocations;
  }
}
